<template>
  <div class="product-list-container container-fluid">
    <div class="header flex-wrap flex " >
      <div class="custom-row mr-3">
        <search-input v-model="Search" placeholder="Search for recipient" class="search-input " />
      </div>
      <div class="buttons-wrapper flex-wrap mt-2">
        <primary-button
          @click.native="$router.push({name: 'company-admin-import-recipient'})"
          class="primary-button my-2 my-md-0 ml-0 mr-2"
        >Import</primary-button>
        <primary-button
          @click.native="$router.push({name: 'company-admin-add-recipient'})"
          class="primary-button my-2 my-md-0 ml-0"
        >Add Recipient</primary-button>
      </div>
    </div>
    <loader :loading="loading" v-if="loading" />
    <template v-if="!loading">
      <not-found v-if="isFound" />
      <div v-else class="table_div" style="width:100%;overflow-x:auto;overflow-y:hidden">
        <table class="Invoice_table">
          <thead>
            <tr class="Invoice_table_header">
              <th style="min-width:200px">Recipients Name</th>
              <th>Phone number</th>
              <th>Address</th>
              <th class="action">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="recipient in recipients" :key="recipient.index" class="table table-body">
              <th>
                <div :class="!recipient.enabled ? 'deactiveCircle' :'circle'" @click="changeStatus(recipient)" class="status"></div>
                {{recipient.recipient_name}}
              </th>
              <th>{{recipient.phone_number}}</th>
              <th>{{recipient.address}}</th>
              <th class="action">
                <img
                        title="Edit"
                  @click="$router.push({name: 'company-admin-edit-recipient', params: {id: recipient.recipient_uuid}})"
                  src="@/assets/Icon/Edit.svg"
                  alt
                />
                <img
                        title="Delete"
                  @click="showAlert(recipient.recipient_uuid)"
                  src="@/assets/Icon/Delete.svg"
                  alt
                />
              </th>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="per-page">
        <span class="filter_by">Show Per Page:</span>
        <div class="primary-input-container choose-type perPage">
          <primary-select
            type="text"
            @input="changePerPage"
            v-model="per_page" :is-cross="false"
            class="choose-type perPage"
            placeholder="Select"
          >
            <option :value="item" v-for="(item,key) in pages" :key="key">{{item}}</option>
          </primary-select>
        </div>
      </div>
      <pagination-component
        v-if="!isFound"
        @change-page="changePage($event)"
        :page="Page"
        :perPage="per_page"
        :total="TotalPages"
        :qnt="recipients.length"
      />
    </template>
  </div>
</template>

<script>
export default {
  components: {
    SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    PaginationComponent: () => import("@/components/Pagination.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    AppDropzone: () => import("@/components/Dropzone"),
    Loader: () => import("@/components/Loader.vue"),
    NotFound: () => import("@/components/NotFound.vue"),
  },
  data: () => ({
    recipients: [],
    Search: "",
    Page: 0,
    TotalPages: null,
    IsUpload: false,
    file: null,
    pages: [10, 20, 50, 100, 200],
    per_page: 10,
    loading: true,
    isFound: false,
  }),
  created() {
    this.GetList();
  },
  watch: {
    Search() {
      this.Page = 0;
      this.GetList();
    },
  },
  methods: {
    changePage(page) {
      this.Page = page;
      this.GetList();
    },
    showAlert(recipient_uuid) {
      // Use sweetalert2
      this.$swal({
        title: "Are you sure?",
        text: "You will not be able to recover this recipient!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it",
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch("DeleteRecipient", recipient_uuid).then(() => {
            this.GetList();
            this.$swal(
              "Deleted!",
              "Your recipient has been deleted.",
              "success"
            );
          });
        }
      });
    },
    changePerPage(e) {
      this.GetList();
    },
    GetList() {
      this.loading = true;
      this.isFound = false;
      this.$store
        .dispatch("GetRecipientList", {
          page: this.Page,
          perPage: this.per_page ? this.per_page : 10,
          search: this.Search,
        })
        .then((res) => {
          this.loading = false;
          if (!res.items.length && !this.Search) {
            this.$router.push({ name: "company-admin-add-recipient" });
            return;
          }
          if (!res.items.length) {
            this.isFound = true;
            return;
          }
          this.Page = res.page;
          this.TotalPages = res.total / res.per_page;
          this.recipients = res.items;
        });
    },

    changeStatus(item) {
      console.log("item,", item)
      item.enabled = !item.enabled

      this.$store.dispatch("EditRecipient", {
        recipient_uuid: item.recipient_uuid,
        enabled: item.enabled,
      })
      .then((res) => {
        console.log("res", res)

        this.$snotify.success("Recipient was changed.", {
          timeout: 6000,
        });
        this.GetList();
      })

      console.log("enabl,", item.enabled)
    }
  },
};
</script>

<style lang="scss" scoped>
.product-list-container {
  //padding: 20px;

  .per-page {
    display: flex;
    align-items: center;
    margin-top: 20px;

    span {
      margin-right: 15px;
    }
  }
  .perPage {
    width: 120px;
  }
  .custom-row {

    display: flex;
    span {
      margin-top: 7px;
      margin-left: 20px;
      margin-right: 10px;
    }
  }
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    .search-input {
      display: flex;
      align-items: center;
      max-width: 500px;
      height: 100%;
      background-color: #ffffff;
    }
    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;
      .upload-container {
        height: 155px;
        width: 260px;
      }
      .primary-button {
        height: 40px;
        width: 150px;
        margin-left: 20px;
      }
    }
  }
}
.circle {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  background-color: #24e2b8;
  display: inline-block;
}
.deactiveCircle {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  background-color: #d2305b;
  display: inline-block;
}
table.Invoice_table {
  width: 100%;
  margin-top: 21px;

  th {
    padding-right: 0;
    padding-left: 0;
    text-align: center;
  }
  .status {
    float: left;
    margin-left: 20px;
    margin-top: 14px;
  }
  .action {
    width: 100px;
  }
}
table thead tr {
  background: linear-gradient(135deg, #51a3f3 0%, #51b5f3 100%);
}
table thead th:first-child {
  padding-left: 20px;
  padding-right: 30px;
  width: 14%;
}
table,
tr {
  width: 100%;
  height: 44px;
  box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  background-color: #ffffff;
}
.Invoice_table tbody tr th {
  color: #212b36;
  font-weight: normal;
  font-family: "Helvetica Neue";
  height: 20px;
  font-size: 14px;
  font-weight: normal;
  line-height: 40px;
  padding: 7px 0;
  text-align: center;
}
table tr th {
  padding: 7px 10px 7px 0;
}
table {
  border-collapse: collapse;
}
.Invoice_table_header th {
  color: white;
  padding-left: 10px;
  border-bottom-width: 2px;
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
  border: 1px solid #dee2e6;
  padding: 0.75rem;
  text-align: center;
}
.Invoice_table_popup {
  height: 30px;
  text-align: right;
  position: relative;
  padding: 0;
  float: right;
  .popup_cta {
    cursor: pointer;
    color: #55616e;
  }
}

table thead th:first-child {
  padding-left: 35px;
}
tbody th:first-child {
  padding: 5px 10px 5px 0;
  span {
    padding: 7px 0;
  }
}
tbody th.created_by {
  line-height: 20px;
  height: 20px;
  padding: 7px 0 27px 0;
}
.svg-grey {
  fill: #55616e;
  margin-left: 3px;
}

@media (max-width: 1270px) {
  .product-list-container table.Invoice_table {
    width: 1000px;
  }
}
.table_div::-webkit-scrollbar {
  // width: 5px;
  width: 8px;
  height: 8px;
  background-color: #f5f5f5;
}

.table_div::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-image: -webkit-gradient(
    linear,
    left bottom,
    left top,
    color-stop(0.44, #51a3f3),
    color-stop(0.72, #51a3f3),
    color-stop(0.86, #51a3f3)
  );
}
</style>

